// extracted by mini-css-extract-plugin
module.exports = {"todosList":"TodoList_todosList__1d7p6"};